import React, { useState } from 'react';
import { menuCategories } from '../mock';
import { UtensilsCrossed } from 'lucide-react';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState(menuCategories[0].id);

  const activeMenu = menuCategories.find(cat => cat.id === activeCategory);

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center bg-cover bg-center" style={{ backgroundImage: "url('https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1600')" }}>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center text-white px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            A Journey Through Flavor
          </h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto">
            Explore our extensive menu featuring over 200 dishes across North Indian, Chinese, and Continental cuisines
          </p>
        </div>
      </section>

      {/* Menu Content */}
      <section className="section-padding">
        <div className="container">
          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-3 mb-12">
            {menuCategories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all duration-300 ${
                  activeCategory === category.id
                    ? 'bg-[#E84118] text-white shadow-lg'
                    : 'bg-white text-[#2C3E50] border-2 border-gray-200 hover:border-[#E84118]'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Menu Items */}
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold mb-8 text-center flex items-center justify-center gap-3" style={{ fontFamily: "'Playfair Display', serif", color: '#2C3E50' }}>
                <UtensilsCrossed className="w-8 h-8 text-[#E84118]" />
                {activeMenu.name}
              </h2>

              <div className="space-y-6">
                {activeMenu.items.map((item, index) => (
                  <div key={index} className="border-b border-gray-200 pb-6 last:border-0 hover:bg-[#FFF8F0] p-4 rounded-lg transition-colors duration-200">
                    <div className="flex justify-between items-start mb-2">
                      <h3 className="text-xl font-semibold text-[#2C3E50]">{item.name}</h3>
                      <span className="text-lg font-bold text-[#E84118] whitespace-nowrap ml-4">{item.price}</span>
                    </div>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Must Try Section */}
          <div className="mt-16 bg-[#E84118] text-white rounded-lg p-8 text-center">
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              Chef's Must-Try Recommendations
            </h3>
            <p className="text-lg mb-6">
              Don't miss our signature dishes: Chicken Tandoori Lahori, Chicken Rara Dhaba Style, Grilled Fish, Butter Chicken, Korean Noodles, and our famous Non-Veg Platter
            </p>
            <a href="tel:+919876543210" className="btn-gold inline-block">
              Order Now
            </a>
          </div>

          {/* Download Menu Note */}
          <div className="text-center mt-8">
            <p className="text-gray-600 text-sm">
              Prices are subject to change. For the most current menu and pricing, please contact us directly.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Menu;
